import { ApiPath } from '@app/shared';
import { apiGet, apiPut } from '../../lib/api';
import type { PegawaiRoleRow } from '@app/shared';

export interface PegawaiRoleData {
  pegawai: { id: number; nama: string };
  roles: PegawaiRoleRow[];
  available_roles: Array<{ id: number; kode: string; nama: string; status_aktif: boolean }>;
}

export async function getPegawaiRoles(pegawaiId: number): Promise<PegawaiRoleData> {
  return apiGet(ApiPath.ADMIN.PEGAWAI_ROLE(pegawaiId), null as never);
}

export async function updatePegawaiRoles(
  pegawaiId: number,
  roles: Array<{ role_id: number; tanggal_mulai: string; tanggal_selesai?: string | null }>,
): Promise<PegawaiRoleRow[]> {
  return apiPut(ApiPath.ADMIN.PEGAWAI_ROLE(pegawaiId), { roles }, null as never);
}
